import React from 'react';

import stylesParent from '../frame.module.scss';
import styles from '../styles/stake/stake-confirm.module.scss';
import loading from '../../../../assets/images/loading.png';
import PropTypes from 'prop-types';
import theme from '../../../../theme';

const ConfirmLoading = ({ token, title, descriptionItem }) => {
  return (
    <div className={stylesParent.cardContent}>
      <div>
        <div className={stylesParent.cardTextRow}>
          <div className={stylesParent.cardTextRowLabel}>{title}</div>
          <div className={stylesParent.cardTextRowValue}>
            <b>{token}</b>
          </div>
        </div>
      </div>
      <div className={styles.descriptionContainer}>
        <div>
          <img src={loading} className='rotate' alt='' />
        </div>
        <div className={styles.confirm}>
          <span style={{ color: theme.palette.mantra.pink, fontWeight: 800 }}>Confirming...</span>
        </div>
        {descriptionItem ? <div className={styles.descriptionItem}>{descriptionItem}</div> : null}
      </div>
    </div>
  );
};

ConfirmLoading.propTypes = {
  token: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  descriptionItem: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default ConfirmLoading;
